import { forwardRef, type AnchorHTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';
import { useT } from '@/shared/i18n';

export interface SkipLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  targetId?: string;
}

/**
 * Skip-to-content link. Visually hidden until focused. The target id should
 * match the route's main element.
 */
export const SkipLink = forwardRef<HTMLAnchorElement, SkipLinkProps>(function SkipLink(
  { targetId = 'main-content', className, ...rest },
  ref,
) {
  const { t } = useT();
  return (
    <a
      ref={ref}
      href={`#${targetId}`}
      className={cn(
        'sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-50 ' +
          'focus:rounded-md focus:bg-[var(--brand-primary)] focus:px-4 focus:py-2 ' +
          'focus:text-[var(--text-inverse)]',
        className,
      )}
      {...rest}
    >
      {t('a11y.skip-to-content')}
    </a>
  );
});
